import IAuthenticationService from "../interfaces/authentication_service";
import ILogin from "../interfaces/login_credentials";
import { injectable } from "inversify";
import * as loginCredentials from "../../public/listing/login_credentials.json";

@injectable()
export default class AuthenticationService implements IAuthenticationService
{
	private _isAuthenticated: boolean;
	private _loginCredentials: ILogin;
	constructor()
	{
		this._isAuthenticated = false;
		this._loginCredentials = JSON.parse(JSON.stringify(loginCredentials));
	}

	public async authenticateUser(
		username:string,
		password:string,
		isDisabled: boolean | undefined): Promise<boolean | null>
	{
		if (username && username.length > 0 && password && password.length > 0 && !isDisabled)
		{
			const loginDetails = this._loginCredentials.default.map((filter) => filter);
			this._isAuthenticated = (username === loginDetails[0].userId && password === loginDetails[0].password);
			return (username === loginDetails[0].userId && password === loginDetails[0].password && !isDisabled);
		}
		return false;
	}

	public setTempAuthentication()
	{
		this._isAuthenticated = true;
	}

	public isUserAuthenticated(): boolean
	{
		return this._isAuthenticated;
	}
}
